module.exports = __webpack_public_path__ + "img/toggle-down.83f003b9.svg";